import axios from 'axios'

export default {
  namespaced: true,
  state: {
    userCode: '',
    accessToken: '',
    notLoginRedirectUrl: ''
  },
  getters: {
    isAuth:(state)=>state.accessToken,
    isUserCode:(state)=>state.userCode,
    isNotLoginRedirectUrl:(state)=>state.notLoginRedirectUrl
  },
  mutations: {
    create (state, data) {
      state.accessToken = data.access_token
      state.userCode = data.user_code
    },
    destroy (state) {
      state.userCode = ''
      state.accessToken = ''
    },
    userCode (state, data) {
      state.userCode = data
    },
    createForNotLoginRedirectUrl (state, data) {
      state.notLoginRedirectUrl = data
    },
    deleteForNotLoginRedirectUrl (state) {
      state.notLoginRedirectUrl = ''
    }
  },
  actions: {
    async create({ commit }, data) {
      const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/login', data.user)
      response.data.user_code = data.user.user_code;
      commit('create', response.data)
    },
    async destroy({ commit }, data) {
      const headers = {}
      headers['Content-Type'] = 'application/json'
      headers['Authorization'] = `Bearer ${data}`

      const options = {
        method: 'post',
        url: process.env.VUE_APP_API_BASE_URL + '/logout',
        headers,
        timeout: 15000
      }
      await axios(options)
      commit('destroy')
    },
    async updateUserCode({ commit }, user_code) {
      commit('userCode', user_code)
    },
    async leave({commit}) {
      await axios.delete(process.env.VUE_APP_API_BASE_URL + '/leave')
      commit('destroy')
    },
    async createGoogleUer({ commit }, data) {
      const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/login/google/callback', data)
      commit('create', response.data)
    },
    async createGithubUer({ commit }, data) {
      const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/login/github/callback', data)
      commit('create', response.data)
    },
    async createLittleHeroesUser({ commit }, data) {
      const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/login/little_heroes/callback', data)
      commit('create', response.data)
    },
    deleteAuth({ commit }) {
      commit('destroy')
    },
    createForNotLoginRedirectUrl({ commit }, data) {
      commit('createForNotLoginRedirectUrl', data)
    },
    deleteForNotLoginRedirectUrl({commit}) {
      commit('deleteForNotLoginRedirectUrl')
    }
  }
}